import { render, staticRenderFns } from "./PacienteNuevoAntecedentes.vue?vue&type=template&id=50de85c4&"
import script from "./PacienteNuevoAntecedentes.vue?vue&type=script&lang=js&"
export * from "./PacienteNuevoAntecedentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports